export const Permissions = {
  // User Management
  user_management__menu: 'user_management__menu',
  user_management__view_active_list: 'user_management__view_active_list',
  user_management__view_invitation_list: 'user_management__view_invitation_list',
  user_management__edit_delete_user: 'user_management__edit_delete_user',
  // Data Warehouse Signals
  data_management__view_signal: 'data_management__view_signal',
  data_management__manage_signal: 'data_management__manage_signal',
  // Misc
  misc__see_unmasked_text: 'misc__see_unmasked_text',
} as const

export type PermissionKey = keyof typeof Permissions
